import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ButtonDialog {
  text: string;
  class: string;
  value: any;
}

export interface DataDialog {
  centerContent: boolean;
  icon: string;
  title: string;
  subtitle: string;
  content: string;
  textButtons: string;
  orientationButtons: string;
  buttons: ButtonDialog[];
  
}

@Component({
  selector: 'app-general-dialog',
  templateUrl: './general-dialog.component.html',
  styleUrls: ['./general-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class GeneralDialogComponent implements OnInit {

  annioGravable:number;
  subtitle:string;
  constructor(
    private dialogRef: MatDialogRef<GeneralDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataDialog,
   
  ) {    
   }

  ngOnInit() {
    this.subtitle=this.data.subtitle;
  }

  sendResponse(value: string) {
    this.dialogRef.close(value);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/dialogos/general/general-dialog.component.ts